import { createGlobalStyle } from 'styled-components';

export const global = createGlobalStyle`
  html, body {
    margin: 0;
    padding: 0;
    min-height: 100%;
    width: 100%;
  }
  html {
    font-size: 16px;
    font-family: 'Roboto', sans-serif;
  }
  * {
    box-sizing: border-box;
  }
  a {
    color: inherit;
    text-decoration: none;
  }
  #root {
    min-height: 100%;
    width: 100%;
  }
  .react-tooltip-lite {
    background: #333;
    color: white;
    font-size: 13px;
    * {
      color: white;
    }
  }

  .react-tooltip-lite-arrow {
    border-color: #333;
  }
`;
